<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
<template>
    <li :class="[$style.item]">
      <BaseButton
        :is-primary="!!item.url && item.primary !== false"
        :url="item.url"
        :class="$style.itemButton"
      >
        <span :class="item.shortLabel ? $style['label--long'] : $style['label']">{{ item.label }}</span>
        <span v-if="item.shortLabel" :class="$style['label--short']">{{ item.shortLabel }}</span>
      </BaseButton>
    </li>
</template>
<style lang="scss" module>
@import '@design';
.item {
  margin: $size-grid-size / 2;
  overflow: hidden;

  @media screen and (min-width: $size-breakpoint-md) {
    overflow: visible;
  }
}
.itemButton {
  display: block !important;
  flex-basis: auto;
}
</style>